import * as Fuse from 'fuse.js'

import { Column } from '@/Atomic/Templates/Table'

export interface TableColumnConfig {
  title: string
  accessor: string
  variant?: Column
  sortable?: boolean
}

export type TableSorter = {
  accessor: string
  direction: 'ASC' | 'DESC'
} | null

export enum TableSorterDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type OnColumnReorder = (oldIndex: number, newIndex: number) => void

export type TableAccessors = string[]

// TODO: UseTableFilter should accept any type
export type UseTableFilter = Record<string, unknown> | null
export type UseTableFilters = Record<string, UseTableFilter>
export type UseTableFiltersConditionsMap<T> = {
  [key: string]: (item: T, filter: UseTableFilter) => boolean
}
export type UseTableResult<Item> = Fuse.FuseResult<Item>
